import styled from "@emotion/styled";
import * as React from "react";

type IProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const ExternalLink: React.FC<IProps> = ({ children, ...props }) => (
  <a target="_blank" rel="nofollow noreferrer noopener" {...props}>
    {children}
  </a>
);

export const StyledExternalLink = styled(ExternalLink)`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.linkColor
  };
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
